import React from 'react';
import {connect} from 'react-redux';
import {Form, Grid} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';


const activeList = [
  {
    'key': 'Si',
    'value': 'Si',
    'text': 'Si',
  },
  {
    'key': 'No',
    'value': 'No',
    'text': 'No',
  },
];

const OriginEdit = (props) => {
  const {activeOrigin, activateOrigin} = props;
  const setValue = (name, value) => {
    activateOrigin({
      ...activeOrigin,
      [name]: value,
    });
  };
  return (
    <>
      <div styles={{'display': 'flex', 'flex-wrap': 'nowrap'}}>
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column>
              <Form.Input
                fluid
                label='CÓDIGO DE PAÍS'
                required
                value={activeOrigin.country || ''}
                onChange={(e, {value}) =>
                  setValue('country', value)
                }></Form.Input>
            </Grid.Column>
            <Grid.Column>
              <Form.Input
                fluid
                label='NOMBRE DE PAÍS'
                required
                value={activeOrigin.description || ''}
                onChange={(e, {value}) =>
                  setValue('description', value)
                }></Form.Input>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Form.Input
                fluid
                type='Number'
                min='0'
                max='1000'
                label='TIEMPO DE LLEGADA (MESES)'
                value={activeOrigin.arrival_time || ''}
                onChange={(e, {value}) =>
                  setValue('arrival_time', value)
                }></Form.Input>
            </Grid.Column>
            <Grid.Column>
              <Form.Input
                fluid
                label='CÓDIGO DE PAÍS EQIVALENTE'
                value={activeOrigin.country_equivalence || ''}
                onChange={(e, {value}) =>
                  setValue('country_equivalence', value)
                }></Form.Input>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Form.Dropdown
                label='ORÍGEN ACTIVO'
                placeholder="Seleccionar dealer"
                fluid
                selection
                value={activeOrigin.active}
                onChange={(e, {value}) => setValue('active', value)}
                options={activeList}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    'activeOrigin': state.manageOrders.activeOrigin,
  };
};
const {activateOrigin} = Actions;

export default connect(mapStateToProps, {
  activateOrigin,
})(OriginEdit);
